import React, { memo } from 'react';
import { Image } from 'pcln-design-system';
import { trimAssetUrl } from '../utils';
/** @public */
var ContentfulImage = function (_a) {
    var _b;
    var asset = _a.asset, className = _a.className, _c = _a.fit, fit = _c === void 0 ? 'scale' : _c, _d = _a.focus, focus = _d === void 0 ? 'center' : _d, _e = _a.format, format = _e === void 0 ? 'png' : _e, height = _a.height, _f = _a.quality, quality = _f === void 0 ? 80 : _f, _g = _a.radius, radius = _g === void 0 ? 0 : _g, width = _a.width;
    var title = asset === null || asset === void 0 ? void 0 : asset.title;
    var file = asset === null || asset === void 0 ? void 0 : asset.file;
    var url = trimAssetUrl(file === null || file === void 0 ? void 0 : file.url);
    var dimensions = ((_b = file === null || file === void 0 ? void 0 : file.details) === null || _b === void 0 ? void 0 : _b.image) || {};
    var h = height || dimensions.height;
    var w = width || dimensions.width;
    var heightPixels = h ? "".concat(h, "px") : null;
    var widthPixels = w ? "".concat(w, "px") : null;
    if (!url)
        return null;
    var src = "https:".concat(url, "?fit=").concat(fit, "&f=").concat(focus, "&fm=").concat(format, "&q=").concat(quality, "&r=").concat(radius, "&h=").concat(h, "&w=").concat(w);
    return React.createElement(Image, { src: src, alt: title, height: heightPixels, width: widthPixels, className: className });
};
export default memo(ContentfulImage);
//# sourceMappingURL=ContentfulImage.js.map